<template>
  <div class="vx-row mb-base customTimeDiv">
    <div class="vx-col w-2/3 mb-2">
      <flat-pickr class="w-full" :config="configdateTimePicker" v-model="data.time_from" placeholder="Choose time" />
    </div>
    <div class="vx-col w-1/4 mb-2">
      <vs-select class="w-full selectExample" v-model="data.hours">
        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options1" />
      </vs-select>
    </div>
    <vs-button @click="removeSchedule(day, keyValue)" class="customTimeDivCloseBtn" color="danger" type="filled" icon-pack="feather" icon="icon-archive"></vs-button>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    keyValue: {
      required: true,
    },
    day: {
      required: true,
    },
  },
  components: {
    flatPickr
  },
  data() {
    return {
      // data_local: JSON.parse(JSON.stringify(this.data)),
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true
      },
      options1: [
          { text: '45 Minutes', value: 45 },
          { text: '90 Minutes', value: 90 },
          { text: '135 Minutes', value: 135 },
          { text: '180 Minutes', value: 180 },
      ],

    }
  },

  methods: {
    async removeSchedule(day, index) {
      await this.$root.$emit('removeScheduleParentComponent', day, index)
    },
  },
  created() {

  }
}
</script>

<style type="text/css">

.customTimeDiv{
  margin: 0px;
  border: 1px solid #dadada;
  padding-top: 10px;
  border-radius: 5px;
}

.customTimeErrorDiv{
  margin: 0px;
  border: 1px solid #ea5455;
  padding-top: 10px;
  border-radius: 5px;
}



.customTimeDivCloseBtn{
  position: relative;
  bottom: 15px;
  left: 30px;
}
</style>